/* ============================================================
   elemara-gallery-swipe.js（2026-10-23）
   手机端产品图主图画廊：手指左右滑动切换上一张/下一张。
   覆盖全部 22 个 GAL 族 PDP 模板（.gal-main + 全局 galGo 函数）。
   - 仅移动端（≤749px）生效，桌面端不受影响
   - 复用模板自带 galGo()，箭头/圆点/缩略图/颜色标签联动逻辑全部保持
   - 触点落在按钮/链接/视频上时不触发（避免与原控件冲突）
   - PDP 族模板（amg-g63-v5/v6/v7、g500-v2~v5 等）自带滑动，无需处理
   ============================================================ */
(function () {
  function bind() {
    document.querySelectorAll('.gal .gal-main').forEach(function (main) {
      if (main.dataset.galSwipeBound) return;
      main.dataset.galSwipeBound = '1';
      var sx = 0, sy = 0, st = 0, tracking = false;
      main.addEventListener('touchstart', function (e) {
        tracking = false;
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        if (e.touches.length !== 1) return;
        if (e.target.closest('button, a, video')) return;
        tracking = true;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        st = Date.now();
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches && e.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy, dt = Date.now() - st;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && dt < 600) {
          if (typeof window.galGo === 'function') {
            window.galGo(dx < 0 ? 1 : -1); /* 左滑=下一张，右滑=上一张 */
          }
        }
      }, { passive: true });
      main.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
